// // src/Redux/slices/placesSlice.js
// import { createSlice } from "@reduxjs/toolkit";
// import { fetchPlacesByCategory, fetchPlaceDetailsById } from "../thunks/placesThunks";

// const initialState = {
//   items: [],
//   total: 0,
//   limit: 50,
//   skip: 0,
//   selected: null,
//   status: "idle",     // "idle" | "loading" | "succeeded" | "failed"
//   error: null,
// };

// const placesSlice = createSlice({
//   name: "places",
//   initialState,
//   reducers: {
//     selectPlace(state, action) {
//       state.selected = action.payload || null;
//     },
//     clearPlaces(state) {
//       state.items = [];
//       state.total = 0;
//       state.skip = 0;
//       state.error = null;
//       state.status = "idle";
//     },
//   },
//   extraReducers: (builder) => {
//     // LIST BY CATEGORY
//     builder
//       .addCase(fetchPlacesByCategory.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(fetchPlacesByCategory.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.error = null;
//         state.items = action.payload.items || [];
//         state.total = action.payload.total ?? 0;
//         state.limit = action.payload.limit ?? state.limit;
//         state.skip = action.payload.skip ?? 0;
//       })
//       .addCase(fetchPlacesByCategory.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload || action.error?.message || "Request failed";
//       });

//     // DETAILS BY ID (optionnel)
//     builder
//       .addCase(fetchPlaceDetailsById.pending, (state) => {
//         // on peut afficher un skeleton detail si tu veux
//       })
//       .addCase(fetchPlaceDetailsById.fulfilled, (state, action) => {
//         // tu peux merger dans selected si nécessaire
//         if (state.selected?.place_id === action.meta?.arg?.place_id) {
//           state.selected = { ...(state.selected || {}), ...(action.payload || {}) };
//         }
//       })
//       .addCase(fetchPlaceDetailsById.rejected, () => {
//         // pas bloquant
//       });
//   },
// });

// export const { selectPlace, clearPlaces } = placesSlice.actions;
// export default placesSlice.reducer;


// src/Redux/slices/placesSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchPlacesByCategory, fetchPlaceDetailsById } from "./placesThunks";

const initialState = {
  items: [],
  total: 0,
  limit: 50,
  skip: 0,
  selected: null,
  status: "idle",     // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

const placesSlice = createSlice({
  name: "places",
  initialState,
  reducers: {
    selectPlace(state, action) {
      state.selected = action.payload || null;
    },
    clearPlaces(state) {
      state.items = [];
      state.total = 0;
      state.skip = 0;
      state.error = null;
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    // LIST BY CATEGORY
    builder
      .addCase(fetchPlacesByCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPlacesByCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.items = action.payload.items || [];
        state.total = action.payload.total ?? 0;
        state.limit = action.payload.limit ?? state.limit;
        state.skip = action.payload.skip ?? 0;
      })
      .addCase(fetchPlacesByCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || "Request failed";
      });

    // DETAILS BY ID (optionnel)
    builder
      .addCase(fetchPlaceDetailsById.pending, (state) => {
        // on peut afficher un skeleton detail si tu veux
      })
      .addCase(fetchPlaceDetailsById.fulfilled, (state, action) => {
        // tu peux merger dans selected si nécessaire
        if (state.selected?.place_id === action.meta?.arg?.place_id) {
          state.selected = { ...(state.selected || {}), ...(action.payload || {}) };
        }
      })
      .addCase(fetchPlaceDetailsById.rejected, () => {
        // pas bloquant
      });
  },
});

export const { selectPlace, clearPlaces } = placesSlice.actions;
export default placesSlice.reducer;
